import { z } from "zod";
export const ICAL_SOURCE_STATUSES = ["success", "error"];
export const icalSourceStatusSchema = z.enum(ICAL_SOURCE_STATUSES);
export const IcalSourceStatusEnum = {
    SUCCESS: "success",
    ERROR: "error",
};
